import styled from "@emotion/styled";

import { MDSTextVariant } from "@/mds";

export const AgentOpenTasksBadge = ({ openTasksCount }: { openTasksCount: number }) => (
  <StyledBadge>{formatLabel({ openTasksCount })}</StyledBadge>
);

const formatLabel = ({ openTasksCount }: { openTasksCount: number }) => {
  if (openTasksCount === 1) {
    return "1 open task";
  }

  return `${openTasksCount} open tasks`;
};

const StyledBadge = styled.span`
  background: ${({ theme }) => theme.colors.background.banner.emphasis};
  border-radius: ${({ theme }) => theme.borderRadius.max};
  color: ${({ theme }) => theme.colors.text.emphasis};
  flex: 0 0 auto;
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextXs]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: 20px;
  padding: 0 ${({ theme }) => theme.spacing[2]};
  white-space: nowrap;
`;
